import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import WaterfallChartOutlinedIcon from '@mui/icons-material/WaterfallChartOutlined';
import {
  firmDocumentsUrl,
  firmIntelligenceUrl,
  firmValuationsUrl,
  firmWaterfallUrl,
} from 'common/config/urls';
import { ACCENT, BRAND, YELLOW } from 'theme/prismDesignTokens';

export const FEATURE_CARDS = [
  {
    key: 'intelligence',
    label: 'Intelligence',
    description: 'Customizable summaries of the entire portfolio.',
    icon: <AssessmentOutlinedIcon fontSize="medium" />,
    color: BRAND[100],
    iconColor: BRAND[500],
    getUrl: firmIntelligenceUrl,
  },
  {
    key: 'valuations',
    label: 'Valuations',
    description: 'Find the details and bulk actions on all of the latest valuations.',
    icon: <ShowChartOutlinedIcon fontSize="medium" />,
    color: ACCENT[100],
    iconColor: ACCENT[600],
    getUrl: firmValuationsUrl,
  },
  {
    key: 'waterfalls',
    label: 'Waterfalls',
    description: 'Run a waterfall on any company\'s cap table to quickly find the distributions.',
    icon: <WaterfallChartOutlinedIcon fontSize="medium" />,
    color: BRAND[100],
    iconColor: BRAND[500],
    getUrl: firmWaterfallUrl,
  },
  {
    key: 'documents',
    label: 'Documents',
    description: 'Quickly find the documents that were used for each valuation.',
    icon: <DescriptionOutlinedIcon fontSize="medium" />,
    color: YELLOW[100],
    iconColor: YELLOW[600],
    getUrl: firmDocumentsUrl,
  },
];

export const ALPHA_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const GROUP_CHARS = [...ALPHA_CHARS, '#'];

export const HOME_COMPANY_SEARCH_PLACEHOLDER = 'Search companies...';
export const HOME_PORTFOLIO_COMPANIES_LABEL = 'Portfolio Companies';
export const HOME_LOADING_COMPANIES = 'Loading companies...';
export const HOME_NO_COMPANIES_MATCH_SEARCH = 'No companies match your search.';
export const HOME_NO_COMPANIES_FOUND = 'No companies found.';
